/**
 * Selector for retrieving the disabled sounds array.
 *
 * @param {Object} state - The Redux state.
 * @returns {Array<string>} - The disabled sound id's array.
 */
export function getDisabledSounds(state) {
  return (
    state['features/base/config'].disabledSounds || [
      'ASKED_TO_UNMUTE_SOUND',
      'E2EE_OFF_SOUND',
      'E2EE_ON_SOUND',
      'INCOMING_MSG_SOUND',
      'LIVE_STREAMING_OFF_SOUND',
      'LIVE_STREAMING_ON_SOUND',
      'NO_AUDIO_SIGNAL_SOUND',
      'NOISY_AUDIO_INPUT_SOUND',
      'OUTGOING_CALL_EXPIRED_SOUND',
      'OUTGOING_CALL_REJECTED_SOUND',
      'OUTGOING_CALL_RINGING_SOUND',
      'OUTGOING_CALL_START_SOUND',
      'PARTICIPANT_JOINED_SOUND',
      'PARTICIPANT_LEFT_SOUND',
      'RAISE_HAND_SOUND',
      'REACTION_SOUND',
      'RECORDING_OFF_SOUND',
      'RECORDING_ON_SOUND',
      'TALK_WHILE_MUTED_SOUND'
    ]
  );
}
/**
 * Returns the location of the sounds. On Web it's the relative path to
 * the sounds folder placed in the source root.
 *
 * @returns {string}
 */
export function getSoundsPath() {
  return 'sounds';
}
